<div>
  <div class="header-text">
    <h1 style="font-weight: 600;">
      Rechnungen
    </h1>
    <div class="next-bill">
      <span style="line-height: 32px;">Nächste Rechnungsdatum: </span>
      <span class="billDate" style="line-height: 32px;"> {{ bills?.nextBillDate > 0? (bills?.nextBillDate*1000 | date) :
        "Keine geplante Rechnung" }}</span>
    </div>
  </div>

  <mat-card style="box-shadow: none; padding: 16px 0 0 0;">
    <div class="table" *ngIf="bills">
      <div class="row border">
        <div><b>Beschreibung</b></div>
        <div><b>Status</b></div>
        <div>
          <b>Rechnungsdatum</b>
        </div>
        <div>
          <b>Zahlungsart</b>
        </div>
        <div><b>Herunterladen</b></div>
      </div>
      <div *ngFor="let bill of bills.bills" class="row">
        <div>
          <p> {{ bill.description }}</p>
        </div>
        <div>
          <p> {{ bill.remainingPrice == 0? "bezahlt" : "offen" }}</p>
        </div>
        <div>
          <p> {{ bill.billDate | date }} </p>
        </div>
        <div>
          <p> {{ bill.chargingType.includes("auto") ? "Automatische Online Abbuchung" :
            "Überweisung" }}</p>
        </div>
        <div *ngIf="this.isUserAdminOfOrganisationOrPlattformAdmin()">
          <a mat-button href="{{ bill.link }}">Rechnung
            herunterladen</a>
        </div>
        <div *ngIf="!this.isUserAdminOfOrganisationOrPlattformAdmin()">
          <a mat-button>Rechnung
            herunterladen</a>
        </div>
      </div>

      <mat-paginator [length]=" totalNumberOfElements" [pageIndex]="this.pageIndex" [pageSize]="this.pageSize"
        (page)="onPageChange($event)" [pageSizeOptions]="[5, 10]"></mat-paginator>
    </div>

  </mat-card>
</div>
<div *ngIf="loading" class="loading-overlay-spinner">
  <mat-spinner></mat-spinner>
</div>